import { FiEye, FiEyeOff } from "react-icons/fi";

export interface RankingRowProps {
  label: string;
  /** Cualquier color CSS del marcador y de la barra. */
  color: string;
  /** Monto ya formateado con signo ("-$1,000.00"). */
  amount: string;
  /** Porcentaje ya formateado ("42%"). */
  share: string;
  /** Largo de la barra (0–100) en la escala común del ranking. */
  bar: number;
  /** Visible en la gráfica. Si es false la fila baja a 60% y pierde la barra. */
  shown: boolean;
  onToggleShown(): void;
  /** Nombre accesible del botón ojo ("Mostrar Comida en la gráfica"). */
  toggleLabel: string;
  /** Si existe, el nombre es un botón que selecciona la categoría o cuenta. */
  onSelect?(): void;
  /** Texto secundario bajo el nombre (p. ej. número de movimientos). */
  meta?: string;
}

/**
 * RankingRow: una fila del ranking de una gráfica. Marcador de color, nombre, monto con % del gasto
 * (el texto lleva el dato, no el color), barra proporcional y botón mostrar/ocultar en la gráfica.
 */
export function RankingRow({ label, color, amount, share, bar, shown, onToggleShown, toggleLabel, onSelect, meta }: RankingRowProps) {
  const name = (
    <span className="flex min-w-0 flex-col">
      <span className="flex min-w-0 items-center gap-2 text-base font-medium leading-[22px] text-[var(--ds-ink)]">
        <i aria-hidden="true" className="size-3 flex-none rounded-[4px]" style={{ background: color }} />
        <span className="truncate">{label}</span>
      </span>
      {meta && <span className="pl-5 text-xs leading-4 text-[var(--ds-ink-muted)]">{meta}</span>}
    </span>
  );

  return (
    <div className={`grid grid-cols-[minmax(0,1fr)_auto_44px] items-center gap-x-3 border-t border-[var(--ds-line)] py-3 first:border-t-0 ${shown ? "" : "opacity-60"}`}>
      {onSelect ? (
        <button
          type="button"
          onClick={onSelect}
          className="app-focus-ring min-w-0 cursor-pointer rounded-md border-0 bg-transparent p-0 text-left"
        >
          {name}
        </button>
      ) : (
        <div className="min-w-0">{name}</div>
      )}
      <span className="text-right text-base font-medium leading-[22px] text-[var(--ds-ink)]">
        {amount}
        <small className="block text-xs font-normal leading-4 text-[var(--ds-ink-muted)]">{share}</small>
      </span>
      <button
        type="button"
        aria-label={toggleLabel}
        aria-pressed={shown}
        onClick={onToggleShown}
        className="app-focus-ring flex size-11 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0 text-[var(--ds-ink)]"
      >
        {shown ? <FiEye aria-hidden="true" className="size-[22px]" /> : <FiEyeOff aria-hidden="true" className="size-[22px]" />}
      </button>
      {shown && (
        <div aria-hidden="true" className="col-span-full mt-1 h-2 overflow-hidden rounded-full bg-[var(--ds-line)]">
          <i className="block h-full rounded-full" style={{ width: `${bar}%`, background: color }} />
        </div>
      )}
    </div>
  );
}
